import React, {Component} from 'react';
import {Router, Route} from 'react-router-dom';
import SearchBox from './components/search-box.js';
import history from './utils/HistoryApp';
import SelectCity from './components/select-city';
import LoginScreen from './components/login/login-screen';
import Buslisting from './components/bus-listing';
import SeatLayout from './components/seat-layout';
import Passenger from './components/passenger-page';
import TicketSummary from './components/ticket-summary';
import Ticket from './components/ticket';
import Wallet from './components/wallet';
import Trips from './components/trips';
import TicketFail from './components/transaction-fail';
import BusFilter from './components/bus-filters';
import CancelTicket from './components/cancel-ticket';
import BoardDropingPoints from './components/select-filter';
import Offers from './components/bus-offers';
import ReactGA from 'react-ga';

ReactGA.initialize('UA-42096921-3');

export default class App extends Component {
  render() {
    return (
      <Router history={history} basename={'/rbooking-bus'}>
        <div>
          <Route
            exact
            path="/rbooking-bus"
            component={(props) => <SearchBox {...props} />}
          />
          <Route
            exact
            path="/bus-offers"
            component={(props) => <Offers {...props} />}
          />
          <Route
            path="/select-city/:type"
            component={(props) => <SelectCity {...props} />}
          />
          <Route
            path="/account-login"
            component={(props) => <LoginScreen {...props} />}
          />
          <Route
            path="/rbooking-bus/trips"
            component={(props) => <Trips {...props} />}
          />
          <Route
            path="/rbooking-bus/filters"
            component={(props) => <BusFilter {...props} />}
          />
          <Route
            path="/rbooking-bus/select-filter/:type"
            component={(props) => <BoardDropingPoints {...props} />}
          />
          <Route
            path="/rbooking-bus/wallet"
            component={(props) => <Wallet {...props} />}
          />
          <Route
            path="/rbooking-bus/from/:from/to/:to/:doj"
            component={(props) => <Buslisting {...props} />}
          />
          <Route
            path="/rbooking-bus/seat-select"
            component={(props) => <SeatLayout {...props} />}
          />
          <Route
            path="/rbooking-bus/passenger-page"
            component={(props) => <Passenger {...props} />}
          />
          <Route
            path="/rbooking-bus/ticket-summary"
            component={(props) => <TicketSummary {...props} />}
          />
          <Route
            path="/rbooking-bus/ticket/:bookingId/:email/:provider"
            component={(props) => <Ticket {...props} />}
          />
          <Route
            path="/rbooking-bus/transaction-fail"
            component={(props) => <TicketFail {...props} />}
          ></Route>
          <Route
            path="/rbooking-bus/cancel-ticket/:bookingId?/:email?/:provider?"
            component={(props) => <CancelTicket {...props} />}
          />
        </div>
      </Router>
    );
  }
}
